import { GridApi } from 'ag-grid-community'
import objects from '../../../../../../../../../../utils/objects'
import { GanttRowItem } from '../../GanttRowItem'

export function getWbsItemDisplayName(
  api: GridApi,
  rowIndex: number,
  prefix: string
): string {
  const node = api.getDisplayedRowAtIndex(rowIndex)
  if (!node?.data) return ''
  const wbsItem = objects.getValue(node.data, `${prefix}wbsItem`)
  return wbsItem?.displayName ?? ''
}

export function getWbsItemIconUrl(
  api: GridApi,
  rowIndex: number,
  prefix: string
): string | undefined {
  const node = api.getDisplayedRowAtIndex(rowIndex)
  if (!node?.data) return undefined
  return objects.getValue(node.data, `${prefix}wbsItem.wbsItemType.iconUrl`)
}

export function getWbsItemScheduledDate(
  api: GridApi,
  rowIndex: number,
  prefix: string,
  getGanttRowItem?: (data: unknown) => GanttRowItem | undefined
): { startDate?: string; endDate?: string } | undefined {
  const node = api.getDisplayedRowAtIndex(rowIndex)
  if (!node?.data) return undefined
  // プロジェクト計画は wbsItem.scheduledDate を持つ。プログラム管理など
  // GanttRowItem ベースの画面は wbsItem を持たないため getGanttRowItem で解決する
  // （CP編集ポップアップの日付範囲制限に使う）。
  const wbsItem = objects.getValue(node.data, `${prefix}wbsItem`)
  const scheduledDate =
    wbsItem?.scheduledDate ?? getGanttRowItem?.(node.data)?.scheduledDate
  if (!scheduledDate) return undefined
  return {
    startDate: scheduledDate.startDate,
    endDate: scheduledDate.endDate,
  }
}

export const createVirtualAnchorEl = (position: {
  left: number
  top: number
}) => ({
  getBoundingClientRect: () => ({
    top: position.top,
    left: position.left,
    bottom: position.top,
    right: position.left,
    width: 0,
    height: 0,
    x: position.left,
    y: position.top,
    toJSON: () => ({}),
  }),
})
